import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { compareValues } from 'cityads-v3/utils/arrayUtils';

function getSrc(src, fallbackSrc, errorCount = 0) {
  if (!fallbackSrc) {
    fallbackSrc = []
  } else if (!Array.isArray(fallbackSrc)) {
    fallbackSrc = [fallbackSrc];
  }

  const srcs = [src, ...fallbackSrc].filter(src => !!src);
  let isLast = false;

  if (errorCount >= srcs.length) {
    errorCount = srcs.length - 1;
    isLast = true;
  }

  return {
    src: srcs[errorCount] || null,
    isLast,
  };
}

export default class AbstractWithFallback extends PureComponent {
  static propTypes = {
    src        : PropTypes.string,
    fallbackSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    onError    : PropTypes.func,
  };

  state = {
    ...getSrc(this.props.src, this.props.fallbackSrc),
    errorCount: 0,
  };

  UNSAFE_componentWillReceiveProps({ src, fallbackSrc }) {
    if (src !== this.props.src) {
      // Изменился базовый src. Сбрасываем всё
      this.setState({
        ...getSrc(src, fallbackSrc),
        errorCount: 0
      });
    } else if (this.state.errorCount && (!compareValues(fallbackSrc, this.props.fallbackSrc))) {
      // Изменился фолбечный src, и он сейчас отображается. Заменяем src и начинаем с первого фолбека
      this.setState({
        ...getSrc(src, fallbackSrc, 1),
        errorCount: 1
      });
    }
  }

  onError = (evt) => {
    this.setState(({ errorCount }, { src, fallbackSrc, onError }) => {
      const srcResult = getSrc(src, fallbackSrc, errorCount + 1);

      if (srcResult.isLast && onError) {
        onError(evt);
      }

      return {
        ...srcResult,
        errorCount: errorCount + 1,
      };
    });
  }

  render() {
    return null;
  }
}
